module.exports = __webpack_public_path__ + "img/Success.51bbc5f7.svg";